import {
  GET_AGENT_BATCH_FAILURE,
  GET_AGENT_BATCH_REQUEST,
  GET_AGENT_BATCH_SUCCESS,
  PUT_AGENT_BATCH_CLEAR_MESSAGE,
  PUT_AGENT_BATCH_FAILURE,
  PUT_AGENT_BATCH_REQUEST,
  PUT_AGENT_BATCH_SUCCESS,
} from '../actions/agent-batch'

export const getAgentBatch = (
  state = {
    isFetching: false,
    data: null,
    errorMessage: null,
    count: 0,
  },
  action
) => {
  switch (action.type) {
    case GET_AGENT_BATCH_REQUEST:
      return {
        ...state,
        data: [],
        isFetching: true,
        count: 0,
        approximateItemsInQueue: 0,
        startTime: null,
      }
    case GET_AGENT_BATCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: Array.isArray(action.response.transactions) ? action.response.transactions : [],
        count: Array.isArray(action.response.transactions) ? action.response.transactions.length : 0,
        approximateItemsInQueue: action.response.approximate_items_in_queue || 0,
        startTime: action.response.start_time,
        message: action.response.message,
      }
    case GET_AGENT_BATCH_FAILURE:
      return {
        ...state,
        data: [],
        isFetching: false,
        errorMessage: action.error,
        count: 0,
        approximateItemsInQueue: 0,
        startTime: null,
      }
    default:
      return state
  }
}

export const putAgentBatch = (
  state = {
    isFetching: false,
    results: null,
    errorMessage: null,
    errors: {},
  },
  action
) => {
  switch (action.type) {
    case PUT_AGENT_BATCH_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case PUT_AGENT_BATCH_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response.message,
      }
    case PUT_AGENT_BATCH_FAILURE:
      return {
        ...state,
        errors: action.details,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    case PUT_AGENT_BATCH_CLEAR_MESSAGE:
      return {
        ...state,
        results: null,
      }
    default:
      return state
  }
}
